'use strict';

import md5 from 'md5'
import diff from "deep-diff"
import VueXStore from '../store'

export default {
    /**
     * * 根据用户信息和请求信息生成验证串
     * @param method 请求的 HTTP Method
     * @param uri 请求的 URI
     * @param dataLength 请求 Body 的长度
     * @returns {string} 验证串
     * @param username 用户名
     * @param password 密码
     * @param department 部门
     * @param role 角色
     * @returns {string} 验证串
     */
    token(method, uri, dataLength, username, password, department, role) {
        const ts = new Date().getTime();
        const message = [method.toLowerCase(), uri, dataLength, password].join('#');
        const sign = md5(message);
        const client = [username, department, role].join('#');
        const base64Client = window.btoa(client);
        const tok = [sign, ts, base64Client].join(':');

        // console.log("in token");

        // console.log("===============");
        // window.console.log("message:", message);
        // console.log("method:", method.toLowerCase());
        // console.log("uri:", uri);
        // console.log("dataLength:", dataLength);
        // console.log("username:", username);
        // console.log("password", password);
        // console.log("md5:", sign);
        //
        // console.log("ts:", ts);
        // console.log("sign:", sign);
        // console.log("client", client);
        // console.log("base64Client", base64Client);
        //
        // console.log("tok:", tok);
        return tok;
    },

    buildUrl(uri, params) {
        // window.console.log(params);
        const store = VueXStore.getStoreFromStorage();
        const t = this.token('get', uri, 0, store.username, store.password, store.deptId, store.roleId);
        const q = Object.assign({}, params || {}, {"X-AUTH-TOKEN": t, page: 0});
        const query = Object.keys(q)
            .filter(key => q[key] !== null && q[key] !== undefined
                && (q[key].length === undefined || q[key].length > 0))
            .map(key => key + '=' + encodeURIComponent(q[key]))
            .join('&');
        return `${uri}?${query}`;
    },

    /**
     * 检测密码强度
     * 包含小写字母、大写字母、数字和特殊符号
     */
    passwdStrength(passwd) {
        let strongPassword = new RegExp('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})')
        let mediumPassword = new RegExp('((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{6,}))|((?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.{8,}))')

        if (strongPassword.test(passwd)) {
            return 'strong'
        } else if (mediumPassword.test(passwd)) {
            return 'medium'
        } else {
            return 'weak'
        }
    },

    /**
     * 将时间戳转成yyyy-MM-dd hh:mm:ss字符串
     * @param tms
     * @returns {*}
     */
    timestamp: (tms) => tms && tms.slice(0, -5).replace('T', ' '),

    /**
     * 返回当天日期字符串
     * @returns {string}
     */
    today: () => new Date().toISOString().substring(0, 10),

    /**
     * 返回 [start, end) 数组
     * @param start
     * @param end
     * @returns {any[]}
     */
    range(start, end) {
        return new Array(end - start).fill(start).map((el, i) => start + i);
    },

    /**
     * 克隆一个对象
     * @param obj 源对象
     * @param keys 要克隆的属性
     * @returns {any}
     */
    clone(obj, keys) {
        let o = {};
        if (keys && Array.isArray(keys)) {
            keys.map(k => o[k] = obj[k]);
        } else {
            o = obj;
        }
        return JSON.parse(JSON.stringify(o));
    },

    /**
     * 比较出对象的同
     * @param objDefault 源对象
     * @param obj 目标对象
     */
    changes(objDefault, obj) {
        const differences = diff(objDefault, obj, (path) => path.length > 2);

        let objChanges = {};
        if (differences) {
            // 过滤出修改过的字段
            const fields = differences.filter(
                el => ['N', 'E', 'A'].indexOf(el.kind) >= 0
            ).map(
                el => el.path[0]
            ).filter( // 删除重复的字段名
                (item, index, self) => self.indexOf(item) === index
            );

            fields.forEach(f => objChanges[f] = obj[f]);
        }
        return objChanges;
    },

    /**
     * 分页参数
     * @param p
     */
    paramsPagination(p) {
        let params = {};
        if (p.sortBy) {
            if (p.sortBy.endsWith('.asc') || p.sortBy.endsWith('.desc')) {
                params.sort = p.sortBy
            } else {
                params.sort = p.sortBy + (p.descending ? '.desc' : '.asc')
            }
        }
        if (p.page) {
            params.page = p.page - 1
        }
        if (p.rowsPerPage) {
            params.limit = p.rowsPerPage
        }
        return params;
    },

    /**
     * 检索参数
     * @param obj
     */
    paramsFilters(obj) {
        let params = {};
        Object.keys(obj).forEach(
            k => {
                if (obj[k]) {
                    const val = obj[k].trim();
                    if (val.length > 0) {
                        params[k] = val;
                    }
                }
            }
        );
        return params;
    },

    /**
     * 参数
     * @param key
     * @param value
     */
    param(key, value) {
        let param = {};
        if (value) {
            const val = value.trim();
            if (val.length > 0) {
                param[key] = val;
            }
        }
        return param;
    },

    /**
     * 生成URL查询字符串
     * @param qry
     */
    toApiQuery: function (qry) {
        const paginationKeys = ['page', 'rowsPerPage', 'sortBy', 'descending', 'totalItems'];
        const queryKeys = Object.keys(qry).filter(k => paginationKeys.indexOf(k) < 0);

        const query = {};
        queryKeys.forEach(k => {
            if (qry[k]) {
                let val = qry[k];
                if (Array.isArray(qry[k])) {
                    val = qry[k].map(it => it.toString()).join(",")
                }

                const v = val.toString().trim();
                if (v.length > 0) {
                    query[k] = v
                }
            }
        });

        if (qry['page']) {
            query['page'] = qry['page'] - 1;
        }

        if (qry['rowsPerPage']) {
            query['limit'] = qry['rowsPerPage'];
        }

        if (qry['sortBy']) {
            const dir = qry['descending'] === true ? '.desc' : '.asc';
            query['sort'] = qry['sortBy'] + dir;
        }

        return query;
    },

    /**
     * 日期格式验证
     */
    regexpDate() {
        return /^([0-9]{4}-((0[13-9]|1[012])-(0[1-9]|[12][0-9]|30)|(0[13578]|1[02])-31|02-(0[1-9]|1[0-9]|2[0-8]))|([0-9]{2}(([2468][048]|[02468][48])|[13579][26])|([13579][26]|[02468][048]|0[0-9]|1[0-6])00)-02-29)$/g
    },

    /**
     * 年月验证
     * @returns {RegExp}
     */
    regexpMonth() {
        return /^[0-9]{4}-(0[1-9]|1[0-2])$/g;
    }
};
